import React from 'react';
import { userBadgeClass, userBadgeStyle } from './theme';

interface Props {
  userId: string;
  name: string;
  isDark: boolean;
}

const UserBadge: React.FC<Props> = ({ userId, name, isDark }) => {
  const style = userBadgeStyle(userId, isDark);

  return (
    <span
      className={userBadgeClass}
      style={style}
      title={name}
    >
      {name}
    </span>
  );
};

export default UserBadge;
